module.exports = __webpack_public_path__ + "static/media/Ufesa_banner_vertical.9bab6d38.png";